module.exports = __webpack_public_path__ + "img/about05.5e2905b1.png";